import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import languageLocale from 'utils/LanguageLocale';
import Accordion from 'components/ProductPage/Accordion/Accordion';
import RwdProductPageEN from 'components/ProductPage/locales/RwdProductPage_en_US.js';
import RwdProductPageFR from 'components/ProductPage/locales/RwdProductPage_fr_CA.js';

const getText = text => languageLocale.getLocalisedDataFromResource(RwdProductPageEN, RwdProductPageFR)(text);

function Ingredients({ content }) {
    return content ? (
        <Accordion
            title={getText('ingredients')}
            id='ingredients'
            dataAt='ingredients'
        >
            <div dangerouslySetInnerHTML={{ __html: content }} />
        </Accordion>
    ) : null;
}

export default wrapFunctionalComponent(Ingredients, 'Ingredients');
